import {IBaseFormFieldSettings} from "../base-form-field.settings";

export interface IAutocompleteFieldSettings extends IBaseFormFieldSettings {
  labelKey?: string;
  displayWith?: (item: any) => string;
}
